import { stringify } from 'qs';
import { useQuery } from '@tcs/common/hooks/useQuery';
import { Transaction } from '@tcs/client-portal-api/types/Transaction';
import { Page } from '@tcs/client-portal-api/types/Page';

interface Props {
  loading: boolean;
  data?: Page<Transaction>;
}

export const useAllTransactions = (
  page = 1,
  pageSize = 10,
  accountStatus = 'All'
): Props => {
  const { data, isLoading: loading } = useQuery<Page<Transaction>, Error>(
    `/transactions/all?${stringify({
      page,
      pageSize,
      accountStatus,
    })}`,
    {
      refetchOnMount: false,
    }
  );

  return {
    loading,
    data,
  };
};

export default useAllTransactions;
